export const getTokenFromStorage = (key: string) => {
  if (typeof sessionStorage === 'undefined' || !sessionStorage.getItem('simulation')) {
    return localStorage.getItem(key)
  }

  return sessionStorage.getItem(key)
}
